import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Switch, FormControlLabel } from "@mui/material";
import { SET_DATAGUARD_INCOGNITO } from "../Utility/DataguardConstant";

function DataguardIncognito({loc}) {
  const isIncognito = useSelector((state) => state.DataguardReducer.incognito);
  const dispatch = useDispatch();

  // Toggle Incognito Mode
  const handleToggleIncognito = () => {
    const newValue = !isIncognito;
    dispatch({ type: SET_DATAGUARD_INCOGNITO, payload: newValue });
  };

  return (
    <div className={loc==="overView" ? "sys-guard-incognito-container overViewScreen" : "sys-guard-incognito-container"}>
      <FormControlLabel
        control={
          <Switch
            checked={isIncognito}
            onChange={handleToggleIncognito}
            color="primary"
          />
        }
      />
      <div>
        <img
          title={`Incognito Mode: ${isIncognito ? "Active" : "Inactive"}`}
          src={
            isIncognito
              ? "/sysGuardIcons/incognitoActive.svg"
              : "/sysGuardIcons/incognito.svg"
          }
        />
      </div>
    </div>
  );
}

export default DataguardIncognito;
